import React, { useEffect, useState } from 'react'
import { Paper, Button } from '@mui/material'
import { Divider } from '@mui/material'
import AchievementCard from '../achievement/achievementCard'
import { useParams } from 'react-router-dom'
import api from '../../API/api'
import { useNavigate } from 'react-router-dom'
import { Helmet } from "react-helmet";

const SchoolOverview = (props) => {

    const { id } = useParams()

    // console.log(id, 'sdsab');
    const navigate = useNavigate();
    // const [achivement, setAchivement] = useState();

    //     const params = useParams();
    // 
    //     const [school, setSchool] = useState();
    //     const [course, setCourse] = useState();
    // 
    //     useEffect(() => {
    //         console.log(params.school);
    //         getSchoolData()
    //     }, [params.school]);
    // 
    // 
    //     
    // 
    //     const getSchoolData = () => {
    //         api.getSchoolData(params.school).then((res) => {
    //             console.log("Res", res);
    //             setSchool(res.data.school)
    //             setCourse(res.data.courses)
    // 
    //         })
    //             .catch((err) => {
    //                 console.log(err.response);
    //             })
    //     }

    // function getachiv() {
    //     api.getAchievment().then(res => {
    //         // console.log(id,'res cachiven');
    //         let filterData = res.data.filter(obj => obj.school_id == Number(id))
    //         console.log(res,'filterData');
    //         setAchivement(filterData)
    //     }).catch(err => {

    //     })
    // }

    // useEffect(() => {
    //     getachiv();
    // }, [id])

    return (
        <>

            <Helmet>
                <meta charSet="utf-8" />
                <title>{props.school && props.school.metaTitle}</title>
                <meta name="description" content={props.school && props.school.metaDesc} />

            </Helmet>


            <div className='pt-1'>
                <Paper>
                    <div className="col-12 p-2">
                        <div className="row">
                            <div className="col-md-12">
                                <div className='m-3 text-center'>
                                    <Button variant='contained' color='error'>{props.school && props.school.schoolName} </Button>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <Paper elevation={3}>
                                    <div className='p-3'>
                                        <div className='text-center'>
                                            <h2>School Overview</h2>
                                        </div>
                                        <Divider color='dark' />
                                        <div >
                                            <p className='m-2'>
                                                {props.school &&
                                                    <div dangerouslySetInnerHTML={{ __html: props.school.schoolOverview }} />
                                                }
                                            </p>
                                        </div>
                                    </div>
                                </Paper>
                            </div>


                            <div className="col-md-6">
                                <Paper elevation={3}>
                                    <div className='p-3'>
                                        <div className='text-center'>
                                            <h2>Courses</h2>
                                        </div>
                                        <Divider color='dark' />
                                        <div className='text-center'>
                                            <i>
                                                We are thrilled to offer you a wide range of engaging and informative courses designed to help you enhance your knowledge and skills in various fields.
                                            </i>
                                        </div>

                                        {props.course && props.course.map((c) =>
                                        (
                                            <div className='m-2'>
                                                <Button variant='outlined' color='primary' onClick={() => navigate(`/course/${c.shortName}`)} fullWidth>{c.courseName}</Button>
                                            </div>
                                        ))}

                                        <div className='text-center'>
                                            <p>
                                                To view more information, click the course name.
                                            </p>
                                        </div>

                                    </div>
                                </Paper>
                                <br />
                                <Paper elevation={3}>
                                    <div className='p-3'>
                                        <div className='text-center'>
                                            <h2>Affiliated to </h2>
                                        </div>
                                        <Divider color='dark' />

                                        {props.affilited && props.affilited.map((c) =>
                                        (
                                            <div className='m-2'>
                                                <Button variant='outlined' color='primary' fullWidth>{c.affilited}</Button>
                                            </div>
                                        ))}
                                    </div>
                                </Paper>


                            </div>
                        </div>


                        <div className="row">
                            <div className="col-md-12">
                                <div className="my-4">
                                    <Paper elevation={3}>
                                        <div className='p-3'>

                                            <div className='text-center'>
                                                <h2>Principal Desk</h2>
                                            </div>
                                            <Divider color='dark' />
                                            <div className='row m-2'>

                                                <div className='col-md-2'>
                                                    <div>
                                                        {
                                                            props.school &&
                                                            <>
                                                                <img src={`${process.env.REACT_APP_BACKEND}assets/schools/principalImg/${props.school.principalImg}`} className='col-12' alt='pews school principle' />
                                                            </>
                                                        }
                                                    </div>
                                                    <div>
                                                        <b>{props.school && props.school.principalName}</b>
                                                    </div>
                                                    <div>
                                                        <b> <small> {props.school && props.school.principalDesig} </small> </b>
                                                    </div>
                                                    <Divider />
                                                </div>

                                                <div className='col-md-10'>
                                                    {props.school &&
                                                        <div dangerouslySetInnerHTML={{ __html: props.school.principalMsg }} />
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                    </Paper>
                                </div>
                            </div>
                        </div>
                        {/* achievment */}
                        <AchievementCard id={id} />
                        {/* achievment */}
                    </div>
                </Paper>
            </div>
        </>
    )
}

export default SchoolOverview